import { useNavigate } from "react-router-dom";
import { initialPath } from "~misc/paths";
const CardItem = ({ pesquisas, tipo = "listagem-total", setShowMessageModal }) => {
  const navigate = useNavigate();

  const respondidas = (pesquisa) => {
    const perguntasValidas = pesquisa.pesquisa.slice(1);
    const totalPerguntas = perguntasValidas.length;
    const perguntasRespondidas = perguntasValidas.filter(
      (pergunta) => {
        return pergunta.chosen !== null && pergunta.chosen !== undefined && (Array.isArray(pergunta.chosen) && pergunta.chosen.length > 0)
      }
    ).length;
    if (pesquisa.status === "Não Pesquisado") return "-";

    return `${perguntasRespondidas}/${totalPerguntas}`;
  };

  return (
    <div className="container mt-6">
      {pesquisas.length === 0 ? (
        <p className="text-center  text-primaria px-8 py-4 rounded-[10px] max-w-[400px] mx-auto cursor-pointer font-bold">Nenhuma pesquisa encontrada</p>
      ) : (
        pesquisas.map((item, index) => {
          const inicio = new Date(item.dataInicio);
          const fim = new Date(item.dataFim);
          const today = new Date();
          fim.setHours(23, 59, 59, 59);
          today.setHours(23, 59, 59, 59);

          const invalidPeriod = !(inicio <= today && today <= fim);
              const params = new URLSearchParams(globalThis.location.search);
                       const origem = params.get("origem");



          return (
            <div
              key={index}
              className={`${invalidPeriod && !item.dataResposta ? "bg-gray-200" : "bg-white"} border rounded-lg p-[2rem] shadow-md  hover:shadow-lg mb-6 flex justify-between items-center hover:border-[1px] hover:border-[#1C2B58]`}
              onClick={() => {

                if(!item.dataResposta) {
                  if(!item.permiteResposta) {
                    setShowMessageModal((prev) => ({
                      ...prev,
                      type: "warning",
                      text: "Não é possível enviar respostas para esta pesquisa no momento",
                      submessage: "Envio de respostas bloqueado pelo administrador"
                    }));
                    return;
                  }


                    let queryParams = "";

                    if (origem === "carteira-geral") {
                      queryParams = "?origem=carteira-geral";
                    } else if (origem === "roteirizacao") {
                      queryParams = "?origem=roteirizacao";
                    } else if (origem === "hub-geral-de-formularios") {
                      queryParams = "?origem=hub-geral-de-formularios";
                    } else {
                      queryParams = "?origem=hub-geral-de-formularios";
                    }
                  if(!invalidPeriod) {
                    navigate(`${initialPath}/gestao-de-pesquisa/${item.id}${queryParams}`)
                    return;
                  }else {
                    setShowMessageModal((prev) => ({
                      ...prev,
                      type: "warning",
                      text: "Não é possível enviar respostas para esta pesquisa no momento",
                      submessage: "A data atual não está dentro do prazo de preenchimento"
                    }));
                  }
                } else {
                  if(item.status == "Pesquisado") {
                    navigate(`${initialPath}/gestao-de-pesquisa/visualizar/${item.id}`);
                    return;
                  }
                }
              }}
            >
              {!["historico", "ativos"].includes(tipo) ?
                <div>
                  <h2 className="font-bold text-lg text-[20px]  uppercase rounded-2xl mb-2">{`${item.codigo} - ${item.nome}`}</h2>
                  <p className="text-sm text-gray-500">
                    Pesquisa: <span className="font-bold">{item?.title}</span>
                  </p>
                  <p className="text-sm text-gray-500">
                    Data Limite:{" "}
                    <span className="font-bold">
                      de {item.dataInicio !== "" ? new Date(item.dataInicio)?.toLocaleDateString("pt-BR") : " - "} até {item.dataFim !== "" ? new Date(item.dataFim)?.toLocaleDateString("pt-BR") : " - "}
                    </span>
                  </p>
                  <p className="text-sm text-gray-500">
                    Respondido em:{" "}
                    <span className="font-bold">
                      {item.dataResposta ? new Date(item.dataResposta)?.toLocaleDateString("pt-BR") : " - "}
                    </span>
                  </p>
                  <p className="text-sm text-gray-500">
                    Respondidas: <span className="font-bold">{respondidas(item)}</span>
                  </p>
                </div>
              :
              <div>
                <h2 className="font-bold text-lg text-[20px]  uppercase rounded-2xl mb-2">{item?.title}</h2>
                <p className="text-sm text-gray-500">
                  Prazo Final: <span className="font-bold">{item.dataFim ? new Date(item.dataFim)?.toLocaleDateString("pt-BR") : " - "}</span>
                </p>
                <p className="text-sm text-gray-500">
                  Realizada em:{" "}
                  <span className="font-bold">
                  {item.dataResposta ? new Date(item.dataResposta)?.toLocaleDateString("pt-BR") : " - "}
                  </span>
                </p>
              </div>
              }

              <div>
                <span className="flex items-center flex-col font-bold border-l-2 border-[#E6E6E6] pl-8">
                  {item?.status === "Pesquisado" ? (
                    <>
                      <svg width="37" height="38" viewBox="0 0 37 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.5301 0.287852C9.39048 0.793036 6.35938 2.57604 4.54666 4.35904C1.54527 7.39015 0 11.1047 0 15.4137C0 19.6037 1.57499 23.3183 4.60609 26.29C9.36076 30.9555 16.3145 32.0847 22.1687 29.2022L24.2191 28.1918L28.9738 33.1248C33.4016 37.7012 33.7879 38.0281 34.7983 37.9984C36.1058 37.9984 36.8487 37.2554 36.8487 35.9479C36.8487 35.1456 36.2247 34.3432 32.2426 30.1829C29.7167 27.5381 27.6365 25.2796 27.6365 25.1905C27.6365 25.0716 28.112 24.2098 28.6766 23.2589C30.2813 20.6438 30.7568 18.7419 30.7271 15.1165C30.7271 11.6099 30.311 10.1241 28.6469 7.33071C26.6262 4.03216 23.3871 1.53595 19.6427 0.436436C17.8895 -0.0687483 13.4022 -0.157898 11.5301 0.287852ZM19.9993 5.25054C28.6766 9.29202 28.6172 21.357 19.9102 25.4876C18.5135 26.1414 17.8895 26.2603 15.4527 26.2603C13.0159 26.2603 12.3919 26.1414 10.9357 25.4579C6.27023 23.2886 3.59572 18.3556 4.45751 13.5712C5.79476 6.23119 13.4022 2.16 19.9993 5.25054Z"
                          fill="#9ACA3C"
                        />
                        <path
                          d="M19.8374 10.3704C19.6967 10.4245 18.2465 11.7881 16.6339 13.4115L13.6793 16.3553L12.359 15.0349C11.623 14.3098 10.8871 13.6605 10.7247 13.6063C10.281 13.4332 9.83728 13.6605 9.05805 14.4938C8.44116 15.1323 8.37622 15.2406 8.37622 15.6626C8.37622 16.1172 8.39787 16.1497 10.6814 18.4441C11.9369 19.7211 13.1382 20.8359 13.333 20.9116C13.6252 21.0415 13.7334 21.0415 14.0365 20.9116C14.2313 20.825 16.0819 19.0501 18.3114 16.8207L22.2292 12.8812V12.4159C22.2292 11.9829 22.1751 11.8964 21.45 11.1604C20.6491 10.3704 20.3136 10.1972 19.8374 10.3704Z"
                          fill="#9ACA3C"
                        />
                      </svg>
                    </>
                  ) : (
                    <>
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.79062 0.286713C9.18125 0.428999 7.92187 0.937168 6.94687 1.40468C4.44844 2.64461 2.6 4.53499 1.36094 7.11649C0.264062 9.37275 0 10.5517 0 12.9909C0 15.4301 0.264062 16.6091 1.36094 18.8653C2.64062 21.5281 4.46875 23.3575 7.12969 24.6381C9.38437 25.7358 10.5625 26 13 26C15.4375 26 16.6156 25.7358 18.8703 24.6381C20.3937 23.9063 21.0641 23.4388 22.2422 22.2396C23.4406 21.0606 23.9078 20.3898 24.6391 18.8653C25.7359 16.6091 26 15.4301 26 12.9909C26 10.5517 25.7359 9.37275 24.6391 7.11649C23.3594 4.45369 21.5312 2.62428 18.8703 1.3437C17.8141 0.835533 16.4734 0.327366 15.8844 0.205406C14.4625 -0.0994949 11.1312 -0.0588417 9.79062 0.286713ZM11.0094 8.45805L13 10.4501L15.0312 8.4174L17.0625 6.38473L18.3219 7.66531L19.6016 8.92556L17.5703 10.9582L15.5391 12.9909L17.5703 15.0236L19.6016 17.0562L18.3219 18.3165L17.0625 19.5971L15.0312 17.5644L13 15.5317L10.9688 17.5644L8.9375 19.5971L7.67812 18.3165L6.39844 17.0562L8.42969 15.0236L10.4609 12.9909L8.42969 10.9582L6.41875 8.92556L7.61719 7.70596C8.2875 7.03518 8.87656 6.48636 8.9375 6.48636C8.97812 6.48636 9.93281 7.38073 11.0094 8.45805Z"
                          fill="#FF2E00"
                        />
                      </svg>
                    </>
                  )}
                  <p className="mt-2 w-[120px] text-center">{item?.status}</p>
                </span>
              </div>
            </div>
          )
        })
      )}
    </div>
  );
};

export default CardItem;
